export const APP_NAME = "Indicafix";
export const PERSIST_STORE_NAME = "indicafixstore";
export const REDIRECT_URL_KEY = "redirectUrl";
